import { forwardRef, PropsWithChildren } from 'react';

import { CSS } from '../stitches.config';
import { rem, Scale } from '../util';
import { Box } from './layout';

type StackProps = {
  direction: 'column' | 'row';
  spacing: Scale;
  css?: CSS;
};
export const Stack = forwardRef<HTMLDivElement, PropsWithChildren<StackProps>>(
  ({ children, direction, spacing, css, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        css={{
          display: 'flex',
          flexDirection: direction,
          gap: rem(spacing),
          ...css,
        }}
        {...props}
      >
        {children}
      </Box>
    );
  },
);
